import { createModel } from "@rematch/core";
import { IHistoryState } from "../interfaces/states/IHistoryState";
import { IObjectUpdate } from "../interfaces/IObjectUpdate";
import { revertUpdate } from "../../backend/helpers/undoHelpers";
import { iRootState, Dispatch } from "../store";

export default createModel()({
  state: {
    past: [],
    future: [],
  } as IHistoryState,
  reducers: {
    add: (state: IHistoryState, payload: Array<IObjectUpdate>): IHistoryState => {
      return { ...state, past: [...state.past, payload], future: [] };
    },

    _undo: (state: IHistoryState): IHistoryState => {
      if (state.past.length === 0) {
        return state;
      }
      return { ...state, past: state.past.slice(0, -1), future: [...state.future, state.past[state.past.length - 1]] };
    },
    _redo: (state: IHistoryState): IHistoryState => {
      if (state.future.length === 0) {
        return state;
      }
      return { ...state, future: state.future.slice(0, -1), past: [...state.past, state.future[state.future.length - 1]] };
    },
    clear: (state: IHistoryState): IHistoryState => {
      return { ...state, past: [], future: [] };
    },
  },
  effects: (dispatch0) => ({
    undoAsync: async (_: null, rootState: iRootState) => {
      const dispatch = dispatch0 as Dispatch;
      if (rootState.history.past.length > 0) {
        const updateBatch: IObjectUpdate[] = rootState.history.past[rootState.history.past.length - 1];
        const reverted: IObjectUpdate[] = updateBatch.map(revertUpdate);

        if (await dispatch.items.updateManyAsync(reverted)) {
          dispatch.history._undo();
        }
      }
    },
    redoAsync: async (_: null, rootState: iRootState) => {
      const dispatch = dispatch0 as Dispatch;
      if (rootState.history.future.length > 0) {
        const updateBatch: IObjectUpdate[] = rootState.history.future[rootState.history.future.length - 1];

        if (await dispatch.items.updateManyAsync(updateBatch)) {
          dispatch.history._redo();
        }
      }
    },
  }),
});
